import { render, staticRenderFns } from "./ZdmEditorFeaturesTabs.vue?vue&type=template&id=339d5a7f&scoped=true&"
import script from "./ZdmEditorFeaturesTabs.vue?vue&type=script&lang=js&"
export * from "./ZdmEditorFeaturesTabs.vue?vue&type=script&lang=js&"
import style0 from "./ZdmEditorFeaturesTabs.vue?vue&type=style&index=0&id=339d5a7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339d5a7f",
  null
  
)

export default component.exports